import { Checkbox, FormControlLabel, FormGroup, MenuItem, Radio, Select } from '@mui/material';
import { INCLUDE_DOCUMENTS_AND_NOTES, VALUATIONS_OTHER, VALUATIONS_SUMMARY , VALUATIONS_TITLE} from 'common/constants/valuations';
import {
  StyledFormControl,
  StyledRadioRow,
  StyledRadioText,
  StyledSubOptionsContainer,
} from '../../BaseExcelExportDialog/BaseExcelExportDialog.styles';
import { EXPORT_OPTIONS } from '../CompanyExcelExportDialog.types';
import { SubOptionsRendererProps } from './SubOptionsRenderer.props';

export const SubOptionsRenderer = ({
  currentSelectedOption,
  selectedVersion,
  valuations,
  isLoading,
  includeDocuments,
  formulated,
  isStaffUser,
  onVersionChange,
  onIncludeDocumentsChange,
  onFormulatedChange,
}: SubOptionsRendererProps) => (
  <>
    <StyledRadioRow>
      <FormControlLabel
        value={EXPORT_OPTIONS.VALUATION}
        control={<Radio />}
        label={<StyledRadioText>{VALUATIONS_TITLE}</StyledRadioText>}
      />
      <StyledFormControl size="small">
        <Select
          value={selectedVersion || ''}
          onChange={onVersionChange}
          disabled={isLoading || valuations.length === 0}>
          {valuations.map(valuation => (
            <MenuItem key={valuation.id} value={valuation.id}>
              {valuation.name}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </StyledRadioRow>
    {currentSelectedOption === EXPORT_OPTIONS.VALUATION && (
      <StyledSubOptionsContainer>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={includeDocuments} onChange={e => onIncludeDocumentsChange(e.target.checked)} />
            }
            label={INCLUDE_DOCUMENTS_AND_NOTES}
          />
          {isStaffUser() && (
            <FormControlLabel
              control={<Checkbox checked={formulated} onChange={e => onFormulatedChange(e.target.checked)} />}
              label="Formulated"
            />
          )}
        </FormGroup>
      </StyledSubOptionsContainer>
    )}

    <StyledRadioRow>
      <FormControlLabel
        value={EXPORT_OPTIONS.VALUATION_SUMMARY}
        control={<Radio />}
        label={<StyledRadioText>{VALUATIONS_SUMMARY}</StyledRadioText>}
      />
      <StyledFormControl size="small">
        <Select
          value={selectedVersion || ''}
          onChange={onVersionChange}
          disabled={isLoading || valuations.length === 0}>
          {valuations.map(valuation => (
            <MenuItem key={valuation.id} value={valuation.id}>
              {valuation.name}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </StyledRadioRow>

    <StyledRadioRow>
      <FormControlLabel
        value={EXPORT_OPTIONS.OTHER}
        control={<Radio />}
        label={<StyledRadioText>{VALUATIONS_OTHER}</StyledRadioText>}
      />
    </StyledRadioRow>
  </>
);
